<style scoped="scoped" lang="scss"></style>

<template>
	<div style="display: inline;">
		<!-- table表格 -->
		<yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/basic/mould/adaptMould" getKey="rows"
			:columns="columns">
			<!-- 搜索框插槽 -->
			<template #conditions>
				<el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
					<el-form-item :label="$t('mujubianhao')">
						<el-input v-model="yt.conditions.no"></el-input>
					</el-form-item>
					<el-form-item :label="$t('mujubianma')">
						<el-input v-model="yt.conditions.code"></el-input>
					</el-form-item>
					<el-form-item :label="$t('mujumingcheng')">
						<el-input v-model="yt.conditions.name"></el-input>
					</el-form-item>
					<el-form-item :label="$t('jimopeichanpin')">
						<!-- 跨组件 - 物料信息 -->
						<yi_cross_select multiple :component="'web_base_matter_list'" :min="1"
							:ids.sync="yt.conditions.products"></yi_cross_select>
					</el-form-item>
					<el-form-item :label="$t('jimopeijitai')">
						<!-- 跨组件 - 设备信息 -->
						<yi_cross_select :component="'web_base_equipment_list'" :max="1"
							:ids.sync="yt.conditions.equipmentIds"></yi_cross_select>
					</el-form-item>
					<el-form-item :label="$t('jimopeidunwei')">
						<!-- <yi_number_input :type="'number'" :start.sync="yt.conditions.tonnage"></yi_number_input> -->
						<el-input type="text"
							@input="yt.conditions.tonnage = String(yt.conditions.tonnage).replace(/[^\d]/g,'')"
							v-model="yt.conditions.tonnage"></el-input>
					</el-form-item>
					<el-form-item>
						<el-button @click="yt.get(1)" type="primary" plain="plain">
							{{$t('sousuo')}}
						</el-button>
						<el-button @click="yt.clear({materialId: $attrs.materialId})">{{$t('chongzhi')}}
						</el-button>
						<yi_curd_expand_button></yi_curd_expand_button>
					</el-form-item>
				</el-form>
			</template>
			<!-- 左侧按钮插槽 -->
			<template #buttonsL>
				<el-button size="mini" @click="yt.showEditDialog('xinzeng',null,'w1');setDefaultValue()" type="primary">
					{{$t('xinzeng')}}
				</el-button>
				<el-button size="mini" @click="show = !show" plain>
					{{$t('daoru')}}
				</el-button>
			</template>
			<!-- 右侧按钮插槽 -->
			<template #buttonsR>
				<el-button size="mini" icon="yicon yicon-export" :title="$t('daochu')"  @click="exportExcel()"></el-button>
				<el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')"  @click="yt.showColumnsDialog()"></el-button>
			</template>
			<!-- 操作插槽 -->
			<template #caozuo="scope">
				<el-row :gutter="10">
					<el-col :span="0.1">
						<el-button type="text" @click="yt.showEditDialog('jimopei', scope.row,'70%')">{{$t('jimopei')}}
						</el-button>
					</el-col>
					<el-col :span="0.1">
						<el-button type="text" @click="yt.showEditDialog('bianji', scope.row)">{{$t('bianji')}}
						</el-button>
					</el-col>
					<el-col :span="0.1">
						<el-button type="text"
							@click="yt.showEditDialog('fuzhi', scope.row);setIsCopyEquipmentMould();getCopyMouldNo(scope.row);">
							{{$t('fuzhi')}}
						</el-button>
					</el-col>
					<el-col :span="0.1">
						<el-button type="text" class="font-color-danger"
							@click="yt.remove(scope.row,'/web/basic/mould/delete')">
							{{$t('shanchu')}}
						</el-button>
					</el-col>
				</el-row>
			</template>
			<template #chang*kuan*gao(CM)='scope'>
				{{(((scope.row.length/10).toFixed(1))%1==0?(scope.row.length/10).toFixed(0):(scope.row.length/10).toFixed(1))
				+'*'+(((scope.row.width/10).toFixed(1))%1==0?(scope.row.width/10).toFixed(0):(scope.row.width/10).toFixed(1))
				+'*'+(((scope.row.heigth/10).toFixed(1))%1==0?(scope.row.heigth/10).toFixed(0):(scope.row.heigth/10).toFixed(1))}}
			</template>
			<template #zhongliang(KG)="scope">
				{{(scope.row.weight!=null?(scope.row.weight/1000).toFixed(1):'')%1==0?(scope.row.weight!=null?(scope.row.weight/1000).toFixed(0):''):(scope.row.weight!=null?(scope.row.weight/1000).toFixed(1):'')}}
			</template>
			<template #shifouzhumo="scope">
				{{scope.row.isDominantMode?$t('shi'):$t('fou')}}
			</template>
		</yi_curd_table>
	</div>
</template>
<script type="text/javascript">
	export default {
		/* 唯一命名 */
		name: 'web_order_management_production_plan_customized_mold_list',
		data() {
			return {
				show: false,
				organizationList: [],
				mouldProductList: [],
				columns: [{
					label: 'mujubianhao',
					prop: 'no',
					width: 130
				}, {
					label: 'mujubianma',
					prop: 'code',
					width: 130
				}, {
					label: 'mujumingcheng',
					prop: 'name',
					// width: 130
				}, {
					label: 'zhizaoshang',
					prop: 'manufacturer'
				}, {
					label: 'mujushouming',
					prop: 'lifetime',
					width: 130
				}, {
					label: 'mujuweizhi',
					prop: 'location',
				}, {
					label: 'chang*kuan*gao(CM)',
					type: 'slot',
				}, {
					label: 'zhongliang(KG)',
					type: 'slot',
				}, {
					label: 'zhuangtai',
					prop: 'status',
					type: 'dictionary',
					key: 'BASIC_MOULD_STATUS'
				},{
					label: 'shifouzhumo',
					type: 'slot'
				}]
			};
		},
		created() {
			setTimeout(() => {
				
				this.yt.conditions = {
					materialId: this.$attrs.materialId,
				}
				// this.utils.event_hub.$on('BASE_MOULD_LIST_REFRESH', () => {
				// 	this.yt.get();
				// })
				this.yt.SELECT_URL = "/web/basic/mould/listByIds"
				this.yt.SELECT_RESULT_KEY = "data"
				this.yt.SELECT_ID = "id"
				this.yt.SELECT_TITLE = "name"
				this.yt.get(1);
				this.utils.event_hub.$on('EQUIPMENT_MOULD_REFRESH', () => {
					this.yt.get(1);
				})
			}, 300)

		},
		methods: {
			setDefaultValue(){
				this.yt.editObj.isDominantMode = true;
			},
			exportExcel() {
				// delete this.yt.conditions.orderBy
				let params = this.yt.conditions
				return this.http.get('/web/report/export/basic_mould_export', {
					params
				}).then(res => {
					this.$message.success(this.$t(res.msg))
					this.utils.event_hub.$emit('SHOW_HEADER_EXPORT_DIALOG')
				}).catch(error => {
					this.$message.error(this.$t(error))
				})
			},
			submitEquipmentStanding() {
				let data = this.$refs.equipmentStanding.$refs.yt.list
				let sns = data.map(item => {
					return item.sn
				})

				this.http.post('web/equipment/standing_book/equipmentOrgUpdate', {
					sns
				}).then(res => {
					console.log('wwwww', res.sns)
					this.yt.isShowEditDialog = false
					this.yt.get(1)
				});
			},
			setIsCopyEquipmentMould() {
				this.yt.editObj.isDominantMode = false;
				this.yt.editObj.isCopyEquipmentMould = true;
			},
			beforeCopy(params) {
				//先声明一个数组对象
				let basicMouldVO = params
				let jsonParams = {
					isCopyEquipmentMould: params.isCopyEquipmentMould,
					basicMouldVO: params,
					isDominantMode: this.yt.editObj.isDominantMode 
				}
				return jsonParams;
			},
			// 处理复制时的模具编号,在模具编号后+01,如果01已存在就递增
			async getCopyMouldNo(params) {
				let response = await this.http.get('/web/basic/mould/getNo?mouldId=' + params.id)
				this.yt.editObj.no = response.data;
			}
		}
	};
</script>
